import TaxForm from './TaxForm.js'
import styles from './style.css'
import { connect } from 'react-redux'
import { submitFormCreate, submitFormCreateAllOutlets, submitFormUpdate } from 'actions/library/tax'
import * as mpLibraryTax from 'mixpanel/library/tax'
import _without from 'lodash/without'
import _map from 'lodash/map'

class TaxDetail extends React.Component {
  render () {
    return (
      <div className={styles.wrapper}>
        <TaxForm
          onSubmit={this._onSubmit}
        />
      </div>
    )
  }

  _onSubmit = (values) => {
    const {dispatch, taxes, taxDetail, outletIds, outlets, categories} = this.props
    const itemIds = _without(_map(taxDetail.items, 'item_id'), undefined) // checked...
    const selectedOutletIds = outletIds[0]
    if (values.action === 'save') {
      delete values.action
      if (values.id) {
        mpLibraryTax.libraryUpdateOneOutlet({newName: values}, taxDetail, categories)
        dispatch(submitFormUpdate(values.id, values, taxes, itemIds, selectedOutletIds, outlets))
      } else {
        mpLibraryTax.libraryCreateTax({tax: values, isAllOutlet: false, taxDetail, categories})
        dispatch(submitFormCreate(values, taxes, itemIds, selectedOutletIds, outlets))
      }
    } else {
      delete values.action
      mpLibraryTax.libraryCreateTax({tax: values, isAllOutlet: true, taxDetail, categories})
      dispatch(submitFormCreateAllOutlets(values, taxes, itemIds, selectedOutletIds, outlets))
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

function mapStateToProps (state) {
  const {taxes, taxDetail, outlets, categories} = state.library.tax
  let outletIds = []
  if (outlets.length) {
    outletIds.push(outlets[0].id)
  }
  if (state.form.search.values !== undefined) {
    outletIds = state.form.search.values.outletIds
  }
  return {
    taxes,
    taxDetail,
    outletIds, // selected
    outlets,
    categories
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxDetail)



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxDetail/TaxDetail.js